import { PropsWithChildren } from 'react';
import { DefaultBlockItem } from 'routes/essential-workspace/components/form/blocks/default';
import { ExpandableBlockItem } from 'routes/essential-workspace/components/form/blocks/expandable';
import { ScheduleDatesBlockItem } from 'routes/essential-workspace/components/form/blocks/schedule-dates';
import { EssentialBlockNode } from 'routes/essential-workspace/state/model';

export function BlockItem(props: PropsWithChildren<EssentialBlockNode>) {
  const blockType = props.type;

  switch (blockType) {
    case 'Default':
      return <DefaultBlockItem {...props} />;
    case 'Expandable':
      return <ExpandableBlockItem {...props} />;
    case 'ScheduleModal':
      return <ScheduleDatesBlockItem {...props} />;
    default:
      return null;
  }
}
